export const messages = {
  en: {
    userExpeditingDelivery: {
      queryTitle: 'Query Conditions',
      listTitle: 'Customer Urgent Orders',
      orderIdPlaceholder: 'Please enter order number',
      productNamePlaceholder: 'Please enter product name',
      userNamePlaceholder: 'Please enter user name',
      orderId: 'Order Number',
      productName: 'Product Name',
      userName: 'User Name',
      reminderNote: 'Reminder Note',
      reminderTime: 'Reminder Time',
      orderDetail: 'Order Details'
    }
  },
  zh: {
    userExpeditingDelivery: {
      queryTitle: '查询条件',
      listTitle: '客户催单',
      orderIdPlaceholder: '请输入订单号',
      productNamePlaceholder: '请输入商品名称',
      userNamePlaceholder: '请输入用户名称',
      orderId: '订单号',
      productName: '商品名称',
      userName: '用户名称',
      reminderNote: '催单说明',
      reminderTime: '催单时间',
      orderDetail: '订单详情'
    }
  }
}